import { components } from 'react-select';
import { groupHeadingStyle } from '../selectStyles';

// SOW 4 A1b: Stage and Strategy cells are pills (frame `pipeline`, layers `Frame 444_*`). Values and
// states: files/tasks/sow4-a1-pipeline/spec.md, section b.
export const STAGE_PILL = {
  width: 144,
  height: 40,
  inset: 4,
  bg: '#7F8F79',
  border: '#6E7868',
  text: '#FFFFFF',
  chevron: '#FFFFFF',
  placeholder: '#FFFFFF',
};

export const STRATEGY_PILL = {
  width: 136,
  height: 24,
  inset: 8,
  bg: '#EEF2EB',
  border: '#C8D2C3',
  text: '#3E4A3C',
  chevron: '#3E4A3C',
  // Empty strategy: dash and chevron both #7D8C78 (`—_2`, `—_3`).
  emptyChevron: '#7D8C78',
  placeholder: '#7D8C78',
};

// `stash:chevron-up-light`, 9 x 5.2, translated to its own origin.
export const PillChevron = ({ color }) => (
  <svg width="9" height="5.21" viewBox="0 0 9 5.21" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.85 0.147C8.94 0.24 9 0.37 9 0.501C9 0.632 8.94 0.761 8.85 0.855L4.5 5.208L0.15 0.855C0.05 0.761 0 0.634 0 0.501C0 0.368 0.05 0.241 0.15 0.147C0.24 0.053 0.37 0 0.5 0C0.63 0 0.76 0.053 0.85 0.147L4.5 3.794L8.15 0.147C8.24 0.053 8.37 0 8.5 0C8.63 0 8.76 0.053 8.85 0.147Z"
      fill={color}
    />
  </svg>
);

export const pillIndicator = (pill) => {
  const PillDropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <PillChevron color={props.hasValue ? pill.chevron : (pill.emptyChevron ?? pill.chevron)} />
    </components.DropdownIndicator>
  );
  return PillDropdownIndicator;
};

// lineHeight 'normal' on the value container: the grid cell's own line-height otherwise sizes
// react-select's shared grid track (README.md, "singleValue offset").
export const pillStyles = (pill) => ({
  container: (base) => ({ ...base, width: pill.width, marginLeft: pill.inset }),
  control: (base, state) => ({
    ...base,
    width: pill.width,
    minHeight: pill.height,
    height: pill.height,
    flexWrap: 'nowrap',
    border: `1px solid ${pill.border}`,
    borderRadius: 4,
    backgroundColor: pill.bg,
    boxShadow: 'none',
    cursor: 'pointer',
    opacity: state.isDisabled ? 0.6 : 1,
    '&:hover': { borderColor: pill.border },
  }),
  // 7 inside the 1px border = the drawn 8 from the pill's outer edge.
  valueContainer: (base) => ({ ...base, padding: '0 0 0 7px', height: '100%', lineHeight: 'normal' }),
  singleValue: (base) => ({ ...base, margin: 0, color: pill.text, lineHeight: 'normal' }),
  placeholder: (base) => ({ ...base, margin: 0, color: pill.placeholder, fontSize: 12, lineHeight: 'normal' }),
  input: (base) => ({ ...base, margin: 0, padding: 0, caretColor: 'transparent' }),
  indicatorsContainer: (base) => ({ ...base, height: '100%' }),
  // Chevron's right edge 11.5 from the pill's outer right edge.
  dropdownIndicator: (base) => ({ ...base, padding: '0 10.5px 0 4px' }),
  groupHeading: (base) => ({ ...groupHeadingStyle(base), paddingBottom: 2 }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#E7F0E2' : state.isFocused ? '#f8fef4' : '#fff',
    color: '#17270D',
    cursor: 'pointer',
    fontSize: 13,
    padding: '6px 12px',
  }),
  menu: (base) => ({ ...base, minWidth: 180 }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
});
